import axios from "axios";

import { fetchAuthSession } from "aws-amplify/auth";
import { toast } from "sonner";
import { getApiBaseRoot } from "../config/api";

const API_BASE_ROOT = getApiBaseRoot();
const API_BASE = `${API_BASE_ROOT.replace(/\/+$/, "").replace(/\/api\/v1$/, "")}/api/v1`;

const getAuthToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString(); // Or .accessToken if you're using that
  } catch (error) {
    window.location.reload();
  }
};

export const RegulifyService = {
  //Enough Credits?
  async get_allowed_credits(module_index) {
    try{
      const token = await getAuthToken();

      const response = await axios.post(
        `${API_BASE}/get_allowed_credits/`,
        {
          module_id: module_index,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      // return response.data.allowed_credits;
       if (response.data.allowed_credits <= 0) {
        toast.error("You do not have enough credits!");
        //alert("You do not have enough credits!");
        //return; // Exit early if no credits
        throw new Error("Insufficient credits");
      }
       } catch (error) {
      console.error("Unexpected Error", error);
      throw new Error("Unexpected Error");
    }
  },
  //Bots
  async uploadQueryFile(formData) {    
      // await this.get_allowed_credits(0);

      try {
      const token = await getAuthToken();
      return axios.post(`${API_BASE}/upload_queryfile/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        timeout: 120000,
      });
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async chat_doc_sme(
    question,
    vector_coll_name,
  ) {    
      // await this.get_allowed_credits(0);

      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/chat_doc_sme/`,
        {
          question: question,
          vector_coll_name: vector_coll_name,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async chat_regu_bot(
    question,
    vector_coll_name,
  ) {      
      // await this.get_allowed_credits(0);

      try {    
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/chat_regu_bot/`,
        {
          question: question,
          vector_coll_name: vector_coll_name,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  //PDD
  async pdd_locate_devices(proddescr) {          
      await this.get_allowed_credits(1); 

      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/locate_predicate_devices/`,
        {
          prod_description: proddescr,        
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async pdd_generate_kg(selected_med_spec_value, selected_prod_code_value) {    
    await this.get_allowed_credits(1);        

    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/generate_graph_data/`,
        {
          medicalspeciality_changed_value: selected_med_spec_value,
          regnumber_changed_value: selected_prod_code_value,
          productcode_changed_value: selected_prod_code_value,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async pdd_list_all_devices_for_prodcode(deviceCode) {    
      await this.get_allowed_credits(1);
     
      try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/get_all_fda_devices_for_productcode/`,
        { product_code: deviceCode },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response.data || [];
    } catch (error) {
      console.error("Access denied", error);
      return [];
    }
  },
  //DocReviewer
  async docreviewer_upload_files(formData) {    
      await this.get_allowed_credits(2);
     
      try {
      const token = await getAuthToken();
      return axios.post(`${API_BASE}/upload_docreview_files/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        timeout: 120000,
      });
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  //RiskMgr
  async riskmgr_upload_files(formData) {    
      await this.get_allowed_credits(3);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/upload_riskcreation_prodspec_files/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          timeout: 120000,
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async riskmgr_upload_override_files(formData) {      
      await this.get_allowed_credits(3);
     
      try {
      const token = await getAuthToken();
      return axios.post(`${API_BASE}/upload_risk_override_file/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        timeout: 120000,
      });
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  //ChangeClarity
  async changeclarity_start_fda_change_flow(
    question_id,
    user_answer,
    user_query = "",
  ) {     
      await this.get_allowed_credits(4);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/start_fdachange_ctrl_decision_flow/`,
        {
          question_id: question_id,
          user_answer: user_answer,
          user_query: user_query,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },  
  async start_eumdr_change_ctrl_decision_flow(
    question_id,
    user_answer,
    user_query = "",
  ) {     
      await this.get_allowed_credits(4);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/start_eumdr_change_ctrl_decision_flow/`,
        {
          question_id: question_id,
          user_answer: user_answer,
          user_query: user_query,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async changeclarity_reset_fda_change_flow() {    
      // await this.get_allowed_credits(4);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/reset_fdachange_ctrl_decision_flow/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async reset_eumdr_fdachange_ctrl_decision_flow() {    
      // await this.get_allowed_credits(4);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/reset_eumdr_fdachange_ctrl_decision_flow/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  //ClinicalEvalLitr
  async cle_get_all_clinical_study() {          
      // await this.get_allowed_credits(5);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/get_all_clinical_study/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async cle_create_clinical_study(data) {          
      await this.get_allowed_credits(5);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/create_clinical_study/`,
        data ? data : {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async cle_get_search_count(productName, searchTerm) {    
      await this.get_allowed_credits(5);
     
      try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/get_search_count/`,
        { product_name: productName, search_term: searchTerm },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Access denied", error);
      return [];
    }
  },
  async cle_get_search_history(productName, searchTerm) {      
      await this.get_allowed_credits(5);
     
      try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/get_search_history/`,
        { product_name: productName },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response;
    } catch (error) {
      console.error("Access denied", error);
      return [];
    }
  },
  async cle_get_all_relevant_and_unique_results(productName) {
      await this.get_allowed_credits(5);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/get_all_relevant_and_unique_results/`,
        {
          product_name: productName,
          f1_method: 0,
          f2_method: 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },
  async cle_generate_metrics(productName) {      
      await this.get_allowed_credits(5);
     
      try {
      const token = await getAuthToken();
      return axios.post(
        `${API_BASE}/generate_metrics/`,
        { product_name: productName, f1_method: 1, f2_method: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, 
        },
      );
    } catch (error) {
      console.error("Access denied", error);
    }
  },

  // Deep Literature Analysis
  async dla_get_devices() {
    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/get_all_clinical_study/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response?.data;
    } catch (error) {
      console.error("dla_get_devices", error);
      return { study_list: [] };
    }
  },
  async dla_get_literature_files(product_name) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/get_literature_files/`,
        { product_name },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response?.data;
    } catch (error) {
      console.error("dla_get_literature_files", error);
      return { files: [] };
    }
  },
  async dla_run_ingestion_for_full_text(device_name) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/run_ingestion_for_full_text/`,
        { device_name },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response?.data;
    } catch (error) {
      console.error("dla_run_ingestion_for_full_text", error);
      throw error;
    }
  },
  async dla_download_literature_file(product_name, file_name) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/download_literature_file/`,
        { product_name, file_name },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response?.data;
    } catch (error) {
      console.error("dla_download_literature_file", error);
      throw error;
    }
  },
  async dla_download_deep_report_docx(product_name) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/deep-analysis-report/download`,
        { product_name },
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );
      return response?.data;
    } catch (error) {
      console.error("dla_download_deep_report_docx", error);
      throw error;
    }
  },

  // clean-up
  async cleanupSessionData(session_id, email_id) {
  try {
    return axios.post(
      `${API_BASE}/cleanup_session_data/`,
      {
        session_id,
        email_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Failed to cleanup session data", error);
  }
  },

  // Adverse Events
  async searchAdverseEvents(query, skip = 0) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(
        `${API_BASE}/search_adverse_events/`,
        { search_query: query },
        {
          params: { skip },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error searching adverse events:", error);
      throw error;
    }
  },
  async summarizeAdverseEvents(eventsData) {
    try {
      const token = await getAuthToken();
      const response = await axios.post(`${API_BASE}/summarize_adverse_events/`, eventsData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob', // Important for file downloads
      });
      return response.data;
    } catch (error) {
      console.error("Error generating summary report:", error);
      throw error;
    }
  },
};
